module.exports = __webpack_public_path__ + "img/class_revenue_icon.1e7c13b4.svg";